import { createFileRoute } from "@tanstack/react-router";
import { CityLandingPage, buildCityLandingHead, type CityLandingConfig } from "@/components/CityLandingPage";

const CONFIG: CityLandingConfig = {
  slug: "manitou-springs",
  name: "Manitou Springs",
  region: "Pikes Peak / West Springs",
  heroEyebrow: "Manitou Springs Marketing Hub",
  heroTitle: { lead: "Manitou Springs marketing for ", gold: "tourist + local", trail: " businesses" },
  heroDescription:
    "Manitou is a tourist-driven mountain town six miles west of Colorado Springs — 1.5M+ annual visitors to the Incline, Cave of the Winds, Garden of the Gods gateway, and Manitou Avenue. We build websites and SEO for restaurants, lodging, retail, tour operators, and trades serving the Manitou + west-Springs market.",
  intro:
    "Manitou's economy runs on tourism + a small, loyal local base. The search behavior is unusual: 70%+ mobile, heavily geographic ('things to do near Manitou'), and concentrated June–September. We build sites and SEO designed for that pattern — fast mobile, strong local-pack visibility, and content that wins both visitor and resident intent.",
  neighborhoods: [
    "Manitou Avenue",
    "Ruxton Avenue",
    "Crystal Hills",
    "Iron Springs",
    "Crystal Park",
    "Cog Railway area",
    "Old Colorado City-adjacent",
    "Cascade",
  ],
  marketSnapshot:
    "Manitou's Map Pack is dominated by long-tenured local restaurants and lodging — newcomers and trades have to earn placement with sustained review velocity and photo-rich GBP. Tourist-intent keywords face national OTAs and TripAdvisor; wins come from owning Google's local stack, not fighting OTAs head-on.",
  highlights: [
    {
      title: "Tourist + local content split",
      body: "We write two content tracks: tourist-intent ('best breakfast Manitou Springs') and local-intent ('emergency plumber Manitou'). Both convert; mixing them dilutes both.",
    },
    {
      title: "Mobile-first by default",
      body: "Manitou traffic is 70%+ mobile, often on tourist roaming or weak Ruxton-canyon LTE. Sub-1MB page weights and one-tap call-to-action are non-negotiable.",
    },
    {
      title: "GBP photos that match the search",
      body: "Manitou Map Pack ranking correlates more with photo freshness and review velocity than backlinks. We run a monthly GBP photo + post cadence that holds top-3 placement.",
    },
  ],
  services: [
    { to: "/colorado-springs-seo", title: "SEO", body: "Manitou Map Pack rankings, tourist-intent content, and review velocity for restaurants, lodging, and retail." },
    { to: "/colorado-springs-web-design", title: "Web design", body: "Mobile-first sites built for tourist mobile traffic and locked-down booking / contact conversion." },
    { to: "/colorado-springs-google-maps", title: "Google Maps", body: "Photo-rich GBP optimization, posts, and reviews — the actual ranking factors in Manitou's local pack." },
    { to: "/geo-ai", title: "GEO / AI search", body: "Get cited in ChatGPT, Perplexity, and Google AI Overviews when visitors ask AI about Manitou." },
  ],
  learnArticleSlugs: [
    "/learn/local-seo-guide",
    "/learn/google-business-profile",
    "/learn/get-more-reviews",
    "/learn/website-conversion",
    "/learn/mobile-website-mistakes",
    "/learn/marketing-budget",
  ],
  learnIntro:
    "Manitou businesses win by owning the local pack and converting heavy mobile tourist traffic. These six pieces explain how.",
  closingCta:
    "30-minute call. We'll audit your Manitou Map Pack position, look at the OTAs and franchises taking your tourist clicks, and tell you what to fix first.",
};

export const Route = createFileRoute("/manitou-springs")({
  head: () =>
    buildCityLandingHead(CONFIG, {
      metaTitle: "Manitou Springs Marketing Agency | SEO, Web Design & Maps | CWI",
      metaDescription:
        "Manitou Springs SEO, web design, and Google Maps optimization for restaurants, lodging, retail, and trades. Local Colorado team, transparent reporting, no long-term contracts.",
    }),
  component: () => <CityLandingPage config={CONFIG} />,
});
